import React, { useEffect, useState } from "react";
import { Card, Col, Container, FormGroup, Label, Row } from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import "./Business.scss";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { imageUpload } from "../../services/BannersServices";
import Dropzone from "react-dropzone";
import { Constants } from "../../Constants";
import { EditorState } from "draft-js";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import { stateToHTML } from "draft-js-export-html";
import { useHistory } from "react-router";
import ViewInWeb from "../../components/Common/ViewInWeb";
import axios from "axios";
import { stateFromHTML } from "draft-js-import-html";
import Icon from "@ailibs/feather-react-ts/dist/Icon";

const instance = axios.create({ baseURL: Constants.BASE_URL });

const updateBusiness = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.put(
      `/brokers`,
      { ...data, type: "business" },
      httpOptions
    );
  } catch (error) {
    throw error;
  }
};

const fetchBusiness = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/brokers?type=business`, httpOptions);
  } catch (error) {
    throw error;
  }
};

function Business(props: any) {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const [bannerDesktop, setBannerDesktop] = useState();
  const [bannerMobile, setBannerMobile] = useState();
  const [head, setHead] = useState(EditorState.createEmpty());
  const [footer, setFooter] = useState(EditorState.createEmpty());
  const [content, setContent] = useState<any>([]);
  const [imageTmp, setImageTmp] = useState("");
  const [descriptionTmp, setDescriptionTmp] = useState(
    EditorState.createEmpty()
  );
  const [contentIdEdit, setContentIdEdit] = useState<any>(null);

  useEffect(() => {
    fetch();
  }, []);

  const uploadCallback = async (file: any) => {
    const result = {
      data: {
        link: "",
      },
    };
    try {
      var form = new FormData();
      form.append("file", file);
      let response = await imageUpload({
        form,
        token: "",
        type: "textEdition",
      });
      result.data.link = `${Constants.BASE_URL}${response.data.data.image}`;
    } catch (error: any) {
      console.log(error.response);
    }
    return result;
  };

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await fetchBusiness({
        token: "",
      });
      const { banner_desktop, banner_mobile, content, footer, head } = response.data.data;
      setBannerDesktop(banner_desktop);
      setBannerMobile(banner_mobile);
      setFooter(EditorState.createWithContent(stateFromHTML(footer)));
      setHead(EditorState.createWithContent(stateFromHTML(head)));

      const contentToArray = JSON.parse(content);
      const contentToHook: any = [];
      contentToArray.map((item: any) => {
        contentToHook.push({
          image: item.image,
          description: EditorState.createWithContent(
            stateFromHTML(item.description)
          ),
        });
      });

      setContent(contentToHook);
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const handleAcceptedFiles = async (files: any, hook: string) => {
    for (let file of files) {
      try {
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "news",
        });
        if (hook === "banner_desktop") {
          setBannerDesktop(response.data.data.image);
        } 
        else if (hook === "banner_mobile") {
          setBannerMobile(response.data.data.image);
        }
        else {
          setImageTmp(response.data.data.image);
        }
      } catch (error: any) {
        console.log(error.response);
      }
    }
  };

  const save = async () => {
    setLoading(true);
    try {
      let data = {
        head: stateToHTML(head.getCurrentContent()),
        footer: stateToHTML(footer.getCurrentContent()),
        bannerDesktop,
        bannerMobile,
        content: content.map((item: any) => ({
          image: item.image,
          description: stateToHTML(item.description.getCurrentContent()),
        })),
      };

      await updateBusiness({
        token: "",
        ...data,
      });

      setLoading(false);
      toast(`Brokers actualizado con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const removeContent = (index: number) => {
    const contentTmp = content;
    contentTmp.splice(index, 1);
    setContent([...contentTmp]);
  };

  const editContent = (item: any, index: number) => {
    setContentIdEdit(index);
    setImageTmp(item.image);
    setDescriptionTmp(item.description);
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {loading && <Loading />}
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title="Empresa" breadcrumbItem="Empresa" />
          <Row>
          <Col className="row">
          <FormGroup className="col-md-6">
              <Label>Banner Desktop</Label>
              <Dropzone
                onDrop={(acceptedFiles) => {
                  handleAcceptedFiles(acceptedFiles, "banner_desktop");
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone">
                    <div
                      className="dz-message needsclick mt-2"
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <div className="mb-3">
                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                      </div>
                      <h4>Drop files here or click to upload.</h4>
                    </div>
                  </div>
                )}
              </Dropzone>
              <div className="dropzone-previews mt-3 mb-3" id="file-previews">
                {bannerDesktop && (
                  <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                    <div className="p-2">
                      <Row className="align-items-center">
                        <Col className="col-auto">
                          <img
                            data-dz-thumbnail=""
                            height="80"
                            className="avatar-sm rounded bg-light"
                            alt=""
                            src={`${Constants.BASE_URL}${bannerDesktop}`}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Card>
                )}
              </div>
            </FormGroup>
            <FormGroup className="col-md-6">
              <Label>Banner Mobile</Label>
              <Dropzone
                onDrop={(acceptedFiles) => {
                  handleAcceptedFiles(acceptedFiles, "banner_mobile");
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone">
                    <div
                      className="dz-message needsclick mt-2"
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <div className="mb-3">
                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                      </div>
                      <h4>Drop files here or click to upload.</h4>
                    </div>
                  </div>
                )}
              </Dropzone>
              <div className="dropzone-previews mt-3 mb-3" id="file-previews">
                {bannerMobile && (
                  <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                    <div className="p-2">
                      <Row className="align-items-center">
                        <Col className="col-auto">
                          <img
                            data-dz-thumbnail=""
                            height="80"
                            className="avatar-sm rounded bg-light"
                            alt=""
                            src={`${Constants.BASE_URL}${bannerMobile}`}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Card>
                )}
              </div>
            </FormGroup>
            <div className="row" style={{ marginTop: "1rem" }}>
              <div className="col-12 text-right">
                <ViewInWeb link={`https://mariomendez.uy/propiedades`} />
                <button
                  className="btn btn-primary waves-effect waves-light"
                  onClick={() => save()}
                >
                  Guardar
                </button>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
              <FormGroup className="mt-2" style={{ marginBottom: "2rem" }}>
                <Label>Cabecera</Label>
                <Editor
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  toolbar={{
                    options: ["inline", "blockType", "link", "emoji", "image"],
                    inline: { inDropdown: true },
                    link: { inDropdown: true },
                    image: { uploadCallback },
                  }}
                  editorState={head}
                  onEditorStateChange={(d: any) => setHead(d)}
                />
              </FormGroup>

              <Row>
                <Label>Contenido</Label>
                <Col md={4}>
                  <FormGroup className="mt-2" style={{ marginBottom: "2rem" }}>
                    <Dropzone
                      onDrop={(acceptedFiles) => {
                        handleAcceptedFiles(acceptedFiles, "image");
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone">
                          <div
                            className="dz-message needsclick mt-2"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            <div className="mb-3">
                              <i className="display-4 text-muted bx bxs-cloud-upload" />
                            </div>
                            <h4>Drop files here or click to upload.</h4>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <div className="dropzone-previews mt-3" id="file-previews">
                      {imageTmp && (
                        <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                          <div className="p-2">
                            <Row className="align-items-center">
                              <Col className="col-auto">
                                <img
                                  data-dz-thumbnail=""
                                  height="80"
                                  className="avatar-sm rounded bg-light"
                                  alt=""
                                  src={`${Constants.BASE_URL}${imageTmp}`}
                                />
                              </Col>
                            </Row>
                          </div>
                        </Card>
                      )}
                    </div>
                  </FormGroup>
                </Col>
                <Col md={8}>
                  <FormGroup className="mt-2" style={{ marginBottom: "2rem" }}>
                    <Editor
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorClassName"
                      toolbar={{
                        options: [
                          "inline",
                          "blockType",
                          "link",
                          "emoji",
                          "image",
                        ],
                        inline: { inDropdown: true },
                        link: { inDropdown: true },
                        image: { uploadCallback },
                      }}
                      editorState={descriptionTmp}
                      onEditorStateChange={(d: any) => setDescriptionTmp(d)}
                    />
                  </FormGroup>
                </Col>
                <button
                  className="btn btn-primary waves-effect waves-light mb-2"
                  onClick={() => {
                    if (contentIdEdit !== null) {
                      const contentTmp = content.map(
                        (item: any, index: number) => {
                          if (index === contentIdEdit) {
                            return {
                              description: descriptionTmp,
                              image: imageTmp,
                            };
                          }
                          return item;
                        }
                      );
                      setContent(contentTmp);
                      setContentIdEdit(null);
                    } else {
                      setContent([
                        ...content,
                        { description: descriptionTmp, image: imageTmp },
                      ]);
                    }
                    setDescriptionTmp(EditorState.createEmpty());
                    setImageTmp("");
                  }}
                  style={{
                    width: "max-content",
                    marginLeft: "auto",
                    marginRight: "15px",
                  }}
                >
                  {contentIdEdit !== null ? "Editar" : "Agregar"}
                </button>
              </Row>

              {content.map((item: any, index: number) => (
                <Row
                  className={`mb-4 ${index % 2 !== 0 ? "background-grey" : ""}`}
                >
                  <div
                    style={{
                      position: "absolute",
                      display: "flex",
                      justifyContent: "end",
                      gap: "0.5rem",
                      zIndex: 1,
                      paddingTop: "0.5rem",
                    }}
                  >
                    <button
                      style={{
                        background: "white",
                        border: "1px solid #00339b",
                        borderRadius: "6px",
                      }}
                      onClick={() => editContent(item, index)}
                    >
                      <Icon name="edit" color="#00339b" />
                    </button>
                    <button
                      style={{
                        background: "white",
                        border: "1px solid #ba0b0be0",
                        borderRadius: "6px",
                      }}
                      onClick={() => removeContent(index)}
                    >
                      <Icon name="trash" color="#ba0b0be0" />
                    </button>
                  </div>
                  {index % 2 === 0 ? (
                    <>
                      {item.image && (
                        <Col>
                          <img
                            data-dz-thumbnail=""
                            className="avatar-sm rounded bg-light"
                            alt=""
                            src={`${Constants.BASE_URL}${item.image}`}
                            style={{ width: "100%", height: "auto" }}
                          />
                        </Col>
                      )}

                      {item.description &&
                        stateToHTML(item.description.getCurrentContent()) !==
                          "<p><br></p>" && (
                          <Col className="h-blue">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: stateToHTML(
                                  item.description.getCurrentContent()
                                ),
                              }}
                            />
                          </Col>
                        )}
                    </>
                  ) : (
                    <>
                      {item.description &&
                        stateToHTML(item.description.getCurrentContent()) !==
                          "<p><br></p>" && (
                          <Col className="h-blue">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: stateToHTML(
                                  item.description.getCurrentContent()
                                ),
                              }}
                            />
                          </Col>
                        )}

                      {item.image && (
                        <Col>
                          <img
                            data-dz-thumbnail=""
                            className="avatar-sm rounded bg-light"
                            alt=""
                            src={`${Constants.BASE_URL}${item.image}`}
                            style={{ width: "100%", height: "auto" }}
                          />
                        </Col>
                      )}
                    </>
                  )}
                </Row>
              ))}

              <FormGroup className="mt-2" style={{ marginBottom: "2rem" }}>
                <Label>Footer</Label>
                <Editor
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  toolbar={{
                    options: ["inline", "blockType", "link", "emoji", "image"],
                    inline: { inDropdown: true },
                    link: { inDropdown: true },
                    image: { uploadCallback },
                  }}
                  editorState={footer}
                  onEditorStateChange={(d: any) => setFooter(d)}
                />
              </FormGroup>

              <div className="row" style={{ marginTop: "1rem" }}>
                <div className="col-12 text-right">
                  <ViewInWeb link={`https://mariomendez.uy/empresa`} />
                  <button
                    className="btn btn-primary waves-effect waves-light"
                    onClick={() => save()}
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Business;
